import { render } from "./user-submissions.view.vue?vue&type=template&id=0e2033ab&scoped=true&ts=true"
import script from "./user-submissions.view.vue?vue&type=script&lang=ts"
export * from "./user-submissions.view.vue?vue&type=script&lang=ts"

import "./user-submissions.view.vue?vue&type=style&index=0&id=0e2033ab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2033ab"]])

export default __exports__